// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dividerContainer {
    padding: 6px 0;
    margin: 12px 0;
    border-bottom: 1px solid #ffa600;
    font-family: 'Kim';
}

.dividerContainer span {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/components/bottomBorderDivider/BottomBorderDivider.style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".dividerContainer {\n    padding: 6px 0;\n    margin: 12px 0;\n    border-bottom: 1px solid #ffa600;\n    font-family: 'Kim';\n}\n\n.dividerContainer span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #FFFFFF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
